export const privacyUrl = "https://www.vpaa.uillinois.edu/resources/web_privacy";
export const faqUrl = "https://opensource.ncsa.illinois.edu/confluence/display/CCrop/Frequently+Asked+Questions";
export const croplandUrl = "https://nass.usda.gov/Research_and_Science/Cropland/SARS1a.php";
export const nrecUrl = "https://www.illinoisnrec.org";
export const dssatUrl = "https://dssat.net/";
export const subxUrl = "http://cola.gmu.edu/subx/";
export const iswsUrl = "https://www.isws.illinois.edu/";
